import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import {
  showAuth,
  closeAuth,
  login,
  loginSuccess,
  loginFailure,
  register,
  registerSuccess,
  registerFailure,
  reset,
  resetSuccess,
  resetFailure, showResetForm, showRegisterForm
} from './actions'
import defaultState, { DEFAULT_FORM_TYPE, DEFAULT_VISIBLE } from './defaultState'

const visible = handleActions(
  {
    [showAuth]: () => true,
    [closeAuth]: () => false
  },
  DEFAULT_VISIBLE
)

const submitting = handleActions(
  {
    [combineActions(login, register, reset)]: () => true,
    [combineActions(loginFailure, loginSuccess, registerFailure, registerSuccess, resetFailure, resetSuccess)]: () => false
  },
  defaultState.submitting
)

const submitted = handleActions(
  {
    [combineActions(showAuth, closeAuth)]: () => false,
    [combineActions(loginSuccess, resetSuccess, registerSuccess)]: () => true
  },
  defaultState.submitted
)

const errors = handleActions(
  {
    [combineActions(login, register, reset, closeAuth)]: () => defaultState.errors,
    [combineActions(loginFailure, registerFailure, resetFailure)]: (state, { payload }) => payload
  }, defaultState.errors
)

const response = handleActions(
  {
    [combineActions(login, register, reset)]: () => (defaultState.response),
    [combineActions(loginSuccess, registerSuccess, resetSuccess)]: (state, { payload }) => payload
  }, defaultState.response
)

const formType = handleActions(
  {
    [combineActions(showAuth)]: () => DEFAULT_FORM_TYPE,
    [registerSuccess]: () => 'registerSuccess',
    [showResetForm]: () => 'reset',
    [showRegisterForm]: () => 'register'
  },
  DEFAULT_FORM_TYPE
)

export default combineReducers({ visible, submitting, submitted, errors, response, formType })
